var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20837 3.75H17.8334C19.2123 3.75 20.3334 4.87109 20.3334 6.25V15C20.3334 16.3809 19.2142 17.5 17.8334 17.5H2.83337C1.45251 17.5 0.333374 16.3809 0.333374 15V1.875C0.333374 2.91016 1.17283 3.75 2.20837 3.75ZM15.3334 10.625C15.3334 11.3152 15.8931 11.875 16.5834 11.875C17.2748 11.875 17.8334 11.3164 17.8334 10.625C17.8334 9.93477 17.2736 9.375 16.5834 9.375C15.8931 9.375 15.3334 9.93477 15.3334 10.625Z",
    fill: "#E34B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.0834 1.875V4.09688C18.7162 3.88281 18.2904 3.75 17.8334 3.75H2.20837C1.17283 3.75 0.333374 2.91016 0.333374 1.875C0.333374 0.839844 1.17283 0 2.20837 0H17.2084C18.2435 0 19.0834 0.839453 19.0834 1.875Z",
    fill: "#E34B31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSelected);
export default __webpack_public_path__ + "static/media/wallet-selected.bacce9af679c0d4064c663c425726984.svg";
export { ForwardRef as ReactComponent };